import { gql } from "@apollo/client";

export const GET_ALL_FORMAS_LIQUIDACION = gql`
query formaLiquidacion {
    formaLiquidacion
    {
        idFormaLiquidacion
        descripcion
    }
}`;

export const adaptFormaLiquidacoin = (formaLiquidacion) => {
  return {
    id: formaLiquidacion?.idFormaLiquidacion,
    displayName: formaLiquidacion?.descripcion

  };
};

const adaptFormasLiquidacionArray = (formasLiquidacion) => {

  return structuredClone(formasLiquidacion?.formaLiquidacion)?.
  map((formaLiquidacion) => adaptFormaLiquidacoin(formaLiquidacion)) || [];
};

export default adaptFormasLiquidacionArray;